export const mcityInfo = [
  {
    award_id: '10083',
    award_info: '凭此券可享受MCITY长沙店、上海店、南京店现金抵扣优惠',
    award_name: '90元抵代100元券'
  },
  {
    award_id: '10082',
    award_info: '凭此券可享受MCITY长沙店、上海店、南京店圆桌剧本杀8.8折优惠',
    award_name: '圆桌8.8折优惠券'
  },
  {
    award_id: '10081',
    award_info: '凭此券可享受MCITY长沙店、上海店、南京店圆桌剧本杀8折优惠',
    award_name: '圆桌8折优惠券'
  },
  {
    award_id: '10079',
    award_info: '凭此券可享受MCITY长沙店、上海店、南京店实景剧本杀8.8折优惠',
    award_name: '实景剧本杀8.8折优惠券'
  },
  {
    award_id: '10080',
    award_info: '凭此券可享受长沙店、南京店288元购NZND',
    award_name: '288元购单场畅玩券'
  },
  {
    award_id: '10078',
    award_info: '本券为单人单场，凭此券可免费体验MCITY长沙店、南京店价值128元的圆桌剧本杀、上海店价值98元的森林进化论一次，如需体验其他价格圆桌剧本杀可联系门店客服补相应差价。本券限量三个店总计10份/月，抢完为止(仅限V9会员领取）',
    award_name: '圆桌体验券1张'
  },
]
